(function () {
    'use strict';

    angular.module('ib-apis-destination-info-module', [

    ]);
})();